import { i18n } from '@/i18n';

export const ValidationPattern = (pattern, label = 'validation.pattern') => (value) => {
  const checkValue = String(value).replaceAll(' ', '').replaceAll('-', '');
  if (value !== null && !checkValue?.match(new RegExp(`^${pattern}$`, 'g'))) {
    return i18n.t(label);
  }
  return true;
};
